import React, { Component } from 'react';
import {Link}from 'react-router-dom';

// images

import InfoJumb1 from './images/infoJumbo1.png';
import InfoJumb2 from './images/infoJumbo2.png';
import InfoJumb3 from './images/infoJumbo3.png';

import banner1 from './images/banner1.jpg';

import {Grid, Row, Col, Carousel, Breadcrumb, Button} from 'react-bootstrap';

class Ziersch extends Component {
  render() {
    return (
      <div className='container-fluid'>
        <div className="supMainLS">
          <div className="BC">
          <Breadcrumb className='breadcrumb-item'>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item >
              <Link to="/Suppliers">Lieferanten</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
                <Link to="/Suppliers/WuF">WuF</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Ziersch</Breadcrumb.Item>
          </Breadcrumb>
          </div>
          <img src={banner1} alt="Ziersch Headquater"/>
        </div>
        <div className="supMainTextLS">
          <h1>Ziersch</h1>
        <Grid className="supMainInfo">
          <Row>
            <Col xsHidden smHidden md={5}>
              <Carousel  controls={false} interval={3000}>
                <Carousel.Item >
                    <img  src={InfoJumb1}  alt="Ziersch Kunden-Landkarte"  height="100%" />
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb2} alt="Ziersch Maschinenanlieferung"  height="100%"/>
                </Carousel.Item>
                <Carousel.Item>
                    <img  src={InfoJumb3} alt="Ziersch Gartenzwerge"  height="100%" />
                </Carousel.Item>
              </Carousel>
              </Col>
            <Col xsHidden smHidden md={7}>
              <h4>Die ZIERSCH GmbH hat sich auf die Entwicklung und den Vertrieb von hochpräzisen Flachschleifmaschinen, Profilschleifmaschinen, Portalschleifmaschinen und Rundtischschleifmaschinen spezialisiert. Die Wurzeln des Unternehmens gehen zurück auf Dipl.-Ing. Frank Ziersch, der langjährige Erfahrungen aus der internationalen Schleifmaschinenindustrie in das Unternehmen einbringt.
              Mit einem hochqualifizierten und motivierten Team von Mitarbeitern verfügt die ZIERSCH GmbH über eine auf die Bedürfnisse der Kunden abgestimmte und leistungsfähige Unternehmensstruktur.
              Diese leistungsfähige Unternehmensstruktur in Verbindung mit außerordentlicher Kundennähe sowie den hochwertigen Produkten ermöglichen es der ZIERSCH GmbH im globalen Wettbewerb mit Erfolg zu bestehen.
            </h4>
            </Col>
            <Col xs={12}  mdHidden lgHidden>
              <h4>Die ZIERSCH GmbH hat sich auf die Entwicklung und den Vertrieb von hochpräzisen Flachschleifmaschinen, Profilschleifmaschinen, Portalschleifmaschinen und Rundtischschleifmaschinen spezialisiert.
            </h4>
            </Col>
            <Col xs={12} md={{ span: 7, offset: 2 }}>
              <Button className="supMainButtonWebPage" variant="light" href="https://www.ziersch.com/" target="_blank">Hersteller Homepage</Button>
            </Col>
          </Row>
        </Grid>
      </div>
        <br/>
        <section>
        <div className="supMainKeyWords">
          <br/>
          <Grid >
            <Row>
              <Col xsHidden  sm={4} md={2}>

                <h5>Ausführung aller Maschinenbauteile in stabilem Guss für maximale Steifigkeit</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                  <h5>Ausstattung der Senkrecht- und Querachsen mit vorgespannten Linearführungssystemen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>geschabte und beschichtete Gleitführungen in der Längsachse</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>durchdachte Maschinenkonzeptionen</h5>
              </Col>
              <Col xsHidden  sm={4} md={2}>

                    <h5>direkte Mess-Systeme von Heidenhain in allen Achsen für präzises Positionieren</h5>
              </Col>

            </Row>
            <br/>
            <Row className="show-grid">
              <Col xs={12}  smHidden mdHidden lgHidden>

                  <h5>&#9658; &nbsp; Maschinenbauteile in stabilem Guss</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; vorgespannten Linearführungssysteme</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; geschabte und beschichtete Gleitführungen</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; durchdachte Maschinenkonzeptionen</h5>
              </Col>
              <Col xs={12}  smHidden mdHidden lgHidden>

                    <h5>&#9658; &nbsp; direkte Mess-Systeme</h5>
              </Col>


            </Row>
          </Grid>
          <br/>
        </div>
        </section>
        <section>

        <Grid className="gridUp">
          <center>
          <h1>Produkte</h1>
          </center>
          <Row className="show-grid">
            <Col  xs={12} sm={12}>
              <center>
              <Link to="/Suppliers/Ziersch/Maschinen"><h4 className="buttonBlue">Schleifmaschinen - Übersicht</h4></Link>
            </center>
            </Col>
            {/* <Col  xs={12} sm={6}>
              <center>
              <Link to="/Suppliers/Ziersch/Rundschleifmaschinen"><h4 className="buttonBlue" >Rundschleifmaschinen</h4></Link>
            </center>
            </Col>
            <Col  xs={12} sm={6}>
              <center>
              <Link to="/Suppliers/Ziersch/Rundtischschleifmaschinen"><h4 className="buttonBlue">Rundtischschleifmaschinen</h4></Link>
            </center>
            </Col>
            <Col  xs={12} sm={6}>
              <center>
              <Link to="/Suppliers/Ziersch/Poratlschleifmaschinen"><h4 className="buttonBlue" >Portalschleifmaschinen</h4></Link>
            </center>
            </Col> */}
          </Row>

        </Grid>
        <br/>
      </section>
        </div>
    );
  }
}

export default Ziersch;



// WEBPACK FOOTER //
// ./src/components/pages/supplier/ziersch/mainPageSup.js